export const FEEDTYPE = {
  IMAGE: "image",
  VIDEO: "video",
  DOCUMENT: "document",
};
